<template>
    <NoButtonModal :open="open" @close="close">
        <div>
          <p>
            Your practice has enabled invoices to be auto-generated for clients in attendance at appointments. Please confirm member is present before updating attendance.
          </p>

            <div class="align-right top-20">
                <button class="secondary cancel" @click="close">Cancel</button>
                <button class="primary" @click="submitChanges">Accept</button>
            </div>
        </div>
    </NoButtonModal>
</template>

<script>
    import NoButtonModal from '@/components/general/modals/NoButtonModal';

    export default {
        name: 'AutoGenInvoiceModal',
        components: {
            NoButtonModal
        },
        props: {
            open: { type: Boolean, required: true }
        },
        methods: {
            submitChanges() {
                this.$emit('confirmCreateInvoice');
            },
            close() {
                this.$toasted.error('Attendance not updated');
                this.$emit('close');
            }
        }
    };
</script>

<style scoped></style>
